/**
 * 捐款页入口
 * 复用 Navbar / Footer，主体为两张收款码卡片（微信 / 支付宝）
 * 收款码图片放在 static/images/donate/（copy-webpack-plugin 原样复制到 dist 根），
 * 引用时必须拼 SITE_BASE，子路径部署才不会错位。
 */
import '../../styles/global.css';
import './style.css';
import {
  Navbar,
  Footer,
  BRAND,
  NAV_LINKS,
  FOOTER_LINKS,
  COPYRIGHT,
  SITE_BASE,
  SITE_NAME,
} from '../../components';

// ─── 收款方式 ───
// 收款码图片已裁成纯二维码（不含账户名文字），账户信息不再在页面上重复展示
const METHODS = [
  {
    key: 'wechat',
    brand: '微信支付',
    image: `${SITE_BASE}images/donate/wechat.jpg`,
    alt: '微信收款二维码',
    hint: '打开微信扫一扫',
    accent: 'wechat',
  },
  {
    key: 'alipay',
    brand: '支付宝',
    image: `${SITE_BASE}images/donate/alipay.jpg`,
    alt: '支付宝收款二维码',
    hint: '打开支付宝扫一扫',
    accent: 'alipay',
  },
];

// ─── 款项用途 ───
const USAGE = [
  {
    icon: '🧰',
    title: '服务器与带宽',
    description: '下载中转、接口调用、对象存储的实打实开销。',
  },
  {
    icon: '🔏',
    title: '域名与证书',
    description: '域名续费、DV 证书、签名与发布流程的工具链。',
  },
  {
    icon: '🧪',
    title: '测试设备',
    description: '多平台兼容性验证所需的额外机器和系统版本。',
  },
];

// ─── 渲染页面 ───
function renderPage() {
  const root = document.getElementById('app');
  if (!root) return;

  // Navbar
  const navbar = new Navbar({
    brand: BRAND,
    links: NAV_LINKS,
    activeKey: 'donate',
  });
  root.appendChild(navbar.render());

  // Hero
  const main = document.createElement('main');
  main.className = 'donate-hero';
  main.innerHTML = `
    <div class="container">
      <div class="donate-hero__inner">
        <span class="donate-hero__eyebrow">支持作者</span>
        <h1 class="heading-xl">如果这些工具帮到了你</h1>
        <p class="text-muted donate-hero__desc">
          ${SITE_NAME}下的应用全部免费、开源思路透明、没有广告。钱不多的时候请一杯咖啡；
          有建议或问题，欢迎去<a href="${SITE_BASE}contact/">联系作者</a>聊聊，那比钱更有价值。
        </p>
      </div>
    </div>
  `;
  root.appendChild(main);

  // 收款码
  const codes = document.createElement('section');
  codes.className = 'donate-codes section section--alt';
  codes.innerHTML = `
    <div class="container">
      <div class="donate-codes__grid">
        ${METHODS.map(
          (m) => `
            <div class="donate-code donate-code--${m.accent}">
              <div class="donate-code__head">
                <span class="donate-code__brand">${m.brand}</span>
                <span class="donate-code__hint">${m.hint}</span>
              </div>
              <div class="donate-code__qr">
                <img src="${m.image}" alt="${m.alt}" loading="lazy" />
              </div>
            </div>
          `
        ).join('')}
      </div>
    </div>
  `;
  root.appendChild(codes);

  // 款项用途
  const usage = document.createElement('section');
  usage.className = 'donate-usage section';
  usage.innerHTML = `
    <div class="container">
      <div class="donate-usage__header">
        <h2 class="heading-lg">钱花在哪</h2>
        <p class="text-muted">每一笔的用途都写在这里，不会拿去干别的</p>
      </div>
      <div class="grid grid--3">
        ${USAGE.map(
          (u) => `
            <div class="card donate-usage__card">
              <div class="donate-usage__icon" aria-hidden="true">${u.icon}</div>
              <h3 class="heading-md">${u.title}</h3>
              <p class="text-muted">${u.description}</p>
            </div>
          `
        ).join('')}
      </div>
    </div>
  `;
  root.appendChild(usage);

  // Footer
  const footer = new Footer({
    copyright: COPYRIGHT,
    links: FOOTER_LINKS,
  });
  root.appendChild(footer.render());
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderPage);
} else {
  renderPage();
}